<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showExtraOptionDialog" id="extra-option-dialog">
      <md-dialog-title>Add a new Option</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createOption)">
          <div class="md-layout">
            <div class="md-layout-item md-size-50"></div>

            <div class="md-layout-item md-size-50"></div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel">Cancel</md-button>
            <md-button type="submit" class="md-primary">Create</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
//import bookingApi from "@/services/api/booking";
//import customerApi from "@/services/api/customer";
//import tourApi from "@/services/api/tour";

export default {
  name: "ExtraOptionDialog",

  props: ["showExtraOptionDialog"],

  data() {
    return {
      option: {}
    };
  },

  components: {},

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    createOption() {
      this.$emit("create", this.option);

      // bookingApi.createBooking(this.booking).then(response => {
      //   this.$emit("new-booking", response.data);
      // });
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px;
}
</style>
